import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module block-quote/blockquoteediting
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { Enter } from 'ckeditor5/src/enter.js';
import { Delete } from 'ckeditor5/src/typing.js';
import BlockQuoteCommand from './blockquotecommand.js';
/**
 * The block quote editing.
 *
 * Introduces the `'blockQuote'` command and the `'blockQuote'` model element.
 *
 * @extends module:core/plugin~Plugin
 */
var BlockQuoteEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(BlockQuoteEditing, _Plugin);
  var _super = _createSuper(BlockQuoteEditing);
  function BlockQuoteEditing() {
    _classCallCheck(this, BlockQuoteEditing);
    return _super.apply(this, arguments);
  }
  _createClass(BlockQuoteEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      editor.commands.add('blockQuote', new BlockQuoteCommand(editor));
      schema.register('blockQuote', {
        inheritAllFrom: '$container'
      });
      editor.conversion.elementToElement({
        model: 'blockQuote',
        view: 'blockquote'
      });
      // Postfixer which cleans incorrect model states connected with block quotes.
      editor.model.document.registerPostFixer(function (writer) {
        var changes = editor.model.document.differ.getChanges();
        var _iterator = _createForOfIteratorHelper(changes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            if (entry.type == 'insert') {
              var element = entry.position.nodeAfter;
              if (!element) {
                // We are inside a text node.
                continue;
              }
              if (element.is('element', 'blockQuote') && element.isEmpty) {
                // Added an empty blockQuote - remove it.
                writer.remove(element);
                return true;
              } else if (element.is('element', 'blockQuote') && !schema.checkChild(entry.position, element)) {
                // Added a blockQuote in incorrect place. Unwrap it so the content inside is not lost.
                writer.unwrap(element);
                return true;
              } else if (element.is('element')) {
                // Just added an element. Check that all children meet the scheme rules.
                var range = writer.createRangeIn(element);
                var _iterator2 = _createForOfIteratorHelper(range.getItems()),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var child = _step2.value;
                    if (child.is('element', 'blockQuote') && !schema.checkChild(writer.createPositionBefore(child), child)) {
                      writer.unwrap(child);
                      return true;
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            } else if (entry.type == 'remove') {
              var parent = entry.position.parent;
              if (parent.is('element', 'blockQuote') && parent.isEmpty) {
                // Something got removed and now blockQuote is empty. Remove the blockQuote as well.
                writer.remove(parent);
                return true;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return false;
      });
      var viewDocument = this.editor.editing.view.document;
      var selection = editor.model.document.selection;
      var blockQuoteCommand = editor.commands.get('blockQuote');
      // Overwrite default Enter key behavior.
      // If Enter key is pressed with selection collapsed in empty block inside a quote, break the quote.
      this.listenTo(viewDocument, 'enter', function (evt, data) {
        if (!selection.isCollapsed || !blockQuoteCommand.value) {
          return;
        }
        var positionParent = selection.getLastPosition().parent;
        if (positionParent.isEmpty) {
          editor.execute('blockQuote');
          editor.editing.view.scrollToTheSelection();
          data.preventDefault();
          evt.stop();
        }
      }, {
        context: 'blockquote'
      });
      // Overwrite default Backspace key behavior.
      // If Backspace key is pressed with selection collapsed in first empty block inside a quote, break the quote.
      this.listenTo(viewDocument, 'delete', function (evt, data) {
        if (data.direction != 'backward' || !selection.isCollapsed || !blockQuoteCommand.value) {
          return;
        }
        var positionParent = selection.getLastPosition().parent;
        if (positionParent.isEmpty && !positionParent.previousSibling) {
          editor.execute('blockQuote');
          editor.editing.view.scrollToTheSelection();
          data.preventDefault();
          evt.stop();
        }
      }, {
        context: 'blockquote'
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'BlockQuoteEditing';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "requires",
    get: function get() {
      return [Enter, Delete];
    }
  }]);
  return BlockQuoteEditing;
}(Plugin);
export { BlockQuoteEditing as default };